import { config as vuexModuleDecoratorsConfig } from 'vuex-module-decorators'
import { Store } from 'vuex'
import { initialiseStores } from '~/utils/store-accessor'
vuexModuleDecoratorsConfig.rawError = true
const initializer = (store: Store<any>) => initialiseStores(store)
export const plugins = [initializer]
export * from '~/utils/store-accessor'
